import type { HTMLAttributes, ReactNode } from 'react';
import { badgeStyles, TONE_SOLID, type Tone } from './badgeStyles';
import { cn } from './cn';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  size?: 'sm' | 'md';
  /** Leading icon, sized to the badge. */
  icon?: ReactNode;
  /** Leading status dot in the tone's solid color. */
  dot?: boolean;
}

/** Compact label for status, counts, and categories. */
export const Badge = ({
  tone = 'neutral',
  size = 'sm',
  icon,
  dot = false,
  className,
  children,
  ...props
}: BadgeProps) => (
  <span className={badgeStyles({ tone, size, className })} {...props}>
    {dot && (
      <span
        aria-hidden="true"
        className={cn('size-1.5 rounded-full', TONE_SOLID[tone])}
      />
    )}
    {icon}
    <span className="truncate">{children}</span>
  </span>
);
